import { render, staticRenderFns } from "./MFormMpsPhoneNumber.vue?vue&type=template&id=1f657a20&scoped=true"
import script from "./MFormMpsPhoneNumber.vue?vue&type=script&lang=js"
export * from "./MFormMpsPhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f657a20",
  null
  
)

export default component.exports